    <lib-page-header [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [headerEvent]="headerEvent" [submenuToggle]="submenuToggle" [logoConfiguration]="logoConfiguration"></lib-page-header>

<canvas #canvas class="screenshot" style="display: none;"></canvas>